module.exports = __webpack_public_path__ + "img/chisozanmai_en.0f70e384.png";